import { ReactNode } from "react";
import { SidebarProvider, SidebarTrigger, SidebarInset } from "@/components/ui/sidebar";
import Header from "@/components/layout/Header";
import DashboardSidebar from "./DashboardSidebar";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "@/hooks/use-mobile";

interface DashboardLayoutProps {
  children: ReactNode;
  activeTab: string;
  onTabChange: (tab: string) => void;
  companyName?: string;
  title?: string;
  subtitle?: string;
}

const DashboardLayout = ({
  children,
  activeTab,
  onTabChange,
  companyName,
  title,
  subtitle,
}: DashboardLayoutProps) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  return (
    <div className="min-h-screen bg-gradient-subtle">
      <Header showLogoutButton={true} />
      
      <SidebarProvider defaultOpen={!isMobile}>
        <div className="flex min-h-screen w-full pt-16">
          <DashboardSidebar
            activeTab={activeTab}
            onTabChange={onTabChange}
            companyName={companyName}
          />
          
          <SidebarInset className="flex-1 min-w-0">
            <div className="flex items-center gap-2 sm:gap-4 border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 px-3 sm:px-6 py-3 sm:py-4 sticky top-16 z-30">
              <SidebarTrigger className="-ml-1 sm:-ml-2 shrink-0" />
              <div className="flex-1 min-w-0">
                <h1 className="text-base sm:text-xl font-semibold text-foreground truncate">
                  {title || t("dashboard.title", "HR Dashboard")}
                </h1>
                {subtitle && (
                  <p className="text-xs sm:text-sm text-muted-foreground truncate">{subtitle}</p>
                )}
              </div>
            </div>
            
            <main className="p-3 sm:p-6 overflow-x-hidden">
              {children}
            </main>
          </SidebarInset>
        </div>
      </SidebarProvider>
    </div>
  );
};

export default DashboardLayout;
